"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.MODALS = void 0;
var actions_1 = require("./actions");
var MODALS;
(function (MODALS) {
    MODALS["CONFIRM_ACTION"] = "CONFIRM_ACTION";
})(MODALS = exports.MODALS || (exports.MODALS = {}));
var initialState = Object.keys(MODALS).reduce(function (modalState, modalName) {
    var _a;
    return __assign(__assign({}, modalState), (_a = {}, _a[modalName] = false, _a));
}, {});
var reducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actions_1.ActionTypes.OPEN:
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.modal] = true, _a));
        case actions_1.ActionTypes.CLOSE:
            return __assign(__assign({}, state), (_b = {}, _b[action.payload.modal] = false, _b));
        default:
            return state;
    }
};
exports.reducer = reducer;
